export interface TruckPart {
  id: string;
  name: string;
  category: string;
  price: number;
  image: string;
  description: string;
  reference: string;
  compatibility: string[];
}

export interface TruckModel {
  id: string;
  make: string;
  model: string;
  year: string;
  image: string;
}

export const truckParts: TruckPart[] = [
  {
    id: "p1",
    name: "Filtre à air haute performance",
    category: "Filtration",
    price: 89.99,
    image: "https://images.unsplash.com/photo-1590535113550-027b98427c5e?auto=format&fit=crop&q=80",
    description: "Filtre à air haute performance pour une meilleure respiration du moteur et une consommation optimisée.",
    reference: "FA-9087-HP",
    compatibility: ["Renault T-Series", "Volvo FH", "Mercedes Actros"]
  },
  {
    id: "p2",
    name: "Disques de frein ventilés",
    category: "Freinage",
    price: 199.99,
    image: "https://images.unsplash.com/photo-1600523603974-fd6c0e1b1227?auto=format&fit=crop&q=80",
    description: "Disques de frein ventilés pour un freinage optimisé et une meilleure dissipation de la chaleur.",
    reference: "DF-2345-V",
    compatibility: ["Scania R-Series", "MAN TGX", "DAF XF"]
  },
  {
    id: "p3",
    name: "Kit embrayage renforcé",
    category: "Transmission",
    price: 349.99,
    image: "https://images.unsplash.com/photo-1669988137087-25fbf235dfcc?auto=format&fit=crop&q=80",
    description: "Kit embrayage renforcé pour une durabilité accrue et une meilleure transmission de puissance.",
    reference: "KE-7890-R",
    compatibility: ["Iveco Stralis", "Renault T-Series", "Mercedes Actros"]
  },
  {
    id: "p4",
    name: "Alternateur haute capacité",
    category: "Électricité",
    price: 249.99,
    image: "https://images.pexels.com/photos/3822843/pexels-photo-3822843.jpeg?auto=compress&cs=tinysrgb&w=800",
    description: "Alternateur haute capacité pour une alimentation électrique fiable de tous vos équipements embarqués.",
    reference: "AL-5678-HC",
    compatibility: ["Volvo FH", "Scania R-Series", "MAN TGX"]
  },
  {
    id: "p5",
    name: "Batterie longue durée",
    category: "Électricité",
    price: 179.99,
    image: "https://images.pexels.com/photos/4194778/pexels-photo-4194778.jpeg?auto=compress&cs=tinysrgb&w=800",
    description: "Batterie de haute qualité avec une durée de vie prolongée et une résistance aux conditions extrêmes.",
    reference: "BT-3456-LD",
    compatibility: ["Tous modèles"]
  },
  {
    id: "p6",
    name: "Amortisseurs renforcés",
    category: "Suspension",
    price: 159.99,
    image: "https://images.unsplash.com/photo-1486754735734-325b5831c3ad?auto=format&fit=crop&q=80",
    description: "Amortisseurs renforcés pour un confort de conduite accru et une tenue de route optimale.",
    reference: "AM-1234-R",
    compatibility: ["DAF XF", "Iveco Stralis", "Renault T-Series"]
  }
];

export const popularCategories = [
  {
    id: "c1",
    name: "Filtration",
    count: 124,
    image: "https://images.unsplash.com/photo-1607861716497-e65ab29fc7ac?auto=format&fit=crop&q=80",
  },
  {
    id: "c2",
    name: "Freinage",
    count: 98,
    image: "https://images.unsplash.com/photo-1600523603974-fd6c0e1b1227?auto=format&fit=crop&q=80",
  },
  {
    id: "c3",
    name: "Transmission",
    count: 67,
    image: "https://images.unsplash.com/photo-1669988137087-25fbf235dfcc?auto=format&fit=crop&q=80",
  },
  {
    id: "c4",
    name: "Électricité",
    count: 112,
    image: "https://images.pexels.com/photos/3822843/pexels-photo-3822843.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    id: "c5",
    name: "Suspension",
    count: 45,
    image: "https://images.unsplash.com/photo-1486754735734-325b5831c3ad?auto=format&fit=crop&q=80",
  }
];

export const truckBrands = [
  { id: 1, name: "Renault", logo: "https://images.unsplash.com/photo-1656268164012-119304af0c69?auto=format&fit=crop&q=80" },
  { id: 2, name: "Volvo", logo: "https://images.unsplash.com/photo-1589060841098-3f4dd8ecfa59?auto=format&fit=crop&q=80" },
  { id: 3, name: "Mercedes", logo: "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?auto=format&fit=crop&q=80" },
  { id: 4, name: "Scania", logo: "https://images.unsplash.com/photo-1597987014597-9caeddbb581a?auto=format&fit=crop&q=80" },
  { id: 5, name: "MAN", logo: "https://images.unsplash.com/photo-1551411187-5fde8b9b6614?auto=format&fit=crop&q=80" },
  { id: 6, name: "DAF", logo: "https://images.unsplash.com/photo-1647536448117-f9395ba6316e?auto=format&fit=crop&q=80" },
  { id: 7, name: "Iveco", logo: "https://images.unsplash.com/photo-1606664912624-4c2f10c63155?auto=format&fit=crop&q=80" },
];

export const testimonials = [
  {
    id: 1,
    name: "Thomas Durand",
    role: "Transporteur indépendant",
    content: "Grâce à ce site, j'ai pu commander la pièce exacte dont j'avais besoin en moins de 5 minutes, directement depuis mon téléphone sur une aire de repos. Livraison rapide et prix compétitifs.",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80",
  },
  {
    id: 2,
    name: "Marie Lefèvre",
    role: "Gestionnaire de flotte",
    content: "La recherche par immatriculation est révolutionnaire pour la gestion de notre flotte de 15 camions. Plus besoin de chercher les références pendant des heures.",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80",
  },
  {
    id: 3,
    name: "Jean-Philippe Martin",
    role: "Mécanicien PL",
    content: "Interface claire, recherche efficace et descriptions techniques précises. Exactement ce dont j'ai besoin pour mon atelier de réparation.",
    avatar: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?auto=format&fit=crop&q=80",
  },
];

export const recentSearches = ["XD-456-TG", "AB-987-CD", "ZX-321-WY", "PQ-789-RS"];

export const searchResults = (plate: string) => {
  return {
    vehicle: {
      make: "Renault",
      model: "T-Series",
      year: "2019",
      engine: "13L - 480ch",
      vin: "VF617GPA000012345"
    },
    parts: truckParts.slice(0, 4)
  };
};
